import {
    PermissionEntityType,
    PermissionResourceType,
    PolicyTemplateLink
} from "../../../models";

import { DataStore } from "aws-amplify";
import { PolicyTemplateLinkDAO } from "./PolicyTemplateLinkDAO";

export class DataStorePolicyTemplateLinkDAO implements PolicyTemplateLinkDAO {

    public async listByEntityTypeAndId(
        entityType: PermissionEntityType,
        entityId: string,
        resourceType?: PermissionResourceType
    ): Promise<PolicyTemplateLink[]> {
        if (resourceType) {
            return await DataStore.query(
                PolicyTemplateLink,
                link => link.entityType("eq", entityType)
                    .and(link => link.entityId("eq", entityId))
                    .and(link => link.resourceType("eq", resourceType))
            );
        }
        return await DataStore.query(
            PolicyTemplateLink,
            link => link.entityType("eq", entityType).and(link => link.entityId("eq", entityId))
        );
    }
}

export const dataStorePolicyTemplateLinkDAO = new DataStorePolicyTemplateLinkDAO();